import { AppConfig } from '../AppConfig';

export const ColourPalette = {
  color1: AppConfig.product == "alibi" ? "#00a7cf" :"#377bac",
  color2: '#354058',
  color3: AppConfig.product == "alibi" ? "#00a7cf" :"#377bac",
}